import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ElementRef, HostListener, Injector, ViewChild, afterNextRender, effect } from '@angular/core';

import { InformationService } from './information.service';

@Component({
  selector: 'app-information-panel',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './information-panel.html',
  styleUrl: './information-panel.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InformationPanel {
  @ViewChild('heading') heading?: ElementRef<HTMLHeadingElement>;
  @ViewChild('body') body?: ElementRef<HTMLElement>;

  constructor(readonly information: InformationService, injector: Injector, private readonly host: ElementRef<HTMLElement>) {
    effect(() => {
      information.focusRequest();
      if (!information.expanded()) return;
      afterNextRender(() => {
        if (!information.expanded()) return;
        if (this.body) this.body.nativeElement.scrollTop = 0;
        this.heading?.nativeElement.focus({ preventScroll: true });
      }, { injector });
    });
  }

  @HostListener('document:pointerdown', ['$event'])
  outsidePointer(event: PointerEvent): void {
    const target = event.target as Element | null;
    if (!this.information.expanded() || !target || this.host.nativeElement.contains(target)) return;
    // Another information button switches the topic in the same open panel.
    if (target.closest('app-information')) return;
    this.information.close(false);
  }

  escape(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    this.information.close();
  }
}
